import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  getAllUnitTypesAction,
  setAllUnitTypesAction,
  addUnitTypeAction,
  setAddUnitTypeResponse,
  deleteUnitTypeAction,
  setDeleteUnitTypeResponse,
  getAllSitesAction,
  setAllSitesAction,
  addSiteAction,
  setAddSiteResponse,
  getSingleSitesAction,
  setSingleSitesAction,
  addSiteUnitAction,
  setAddSiteUnitResponse,
  updateSiteUnitAction,
  getSingleSiteUnitAction,
  deleteSiteUnitAction,
  getSiteUnitListAction,
  setSiteUnitListResponse,
  setSingleSiteUnitResponse,
  setDeleteSiteUnitResponse,
  getSingleUnitTypeAction,
  setSingleUnitTypeAction,
  updateSiteUnitStatusAction,
  updateSiteUnitStatusResponse,
} from "../reducers/storageSettingSlice";

/* ✅ v2 base URL, read once here so every saga below can reuse it */
const V2_CONFIG = { baseURL: process.env.REACT_APP_BASE_URL_V2 };

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllUnitTypesSaga(action: { payload: any }): any {
  const { page, limit, orderBy, orderIn } = action.payload;
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/unit-types?page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}`,
      "",
      V2_CONFIG,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(setAllUnitTypesAction(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  } finally {
    yield put(setLoaderAction(false));
  }
  yield put(setLoaderAction(false));
}

function* addUnitTypeSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { time_range, ...rest } = payload.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: rest },
      "post",
      "storage/unit-types",
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddUnitTypeResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* getSingleUnitTypeSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    console.log("action", action);
    const { unitTypeId } = action.payload; // Directly access the payload
    let url = "";

    url = `storage/unit-types/${unitTypeId}`;

    const res = yield call<any>(callAPI, {}, "get", url, "", V2_CONFIG);

    if (res?.data) {
      yield put(setSingleUnitTypeAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* deleteUnitTypeSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `storage/unit-types/${payload?.payload}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteUnitTypeResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  } finally {
    yield put(setLoaderAction(false));
  }
}

// sites
function* getAllSitesSaga(action: { payload: any }): any {
  const { page, limit, orderBy, orderIn } = action.payload;
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/sites?page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}`,
      "",
      V2_CONFIG,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(setAllSitesAction(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* addSiteSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { time_range, ...rest } = payload.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: rest },
      "post",
      "storage/sites",
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSiteResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* getSingleSitesSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    const { id, role } = action.payload; // Directly access the payload
    let url = "";

    url = `storage/sites/${action.payload}`;
    const res = yield call<any>(callAPI, {}, "get", url, "", V2_CONFIG);

    if (res?.data) {
      yield put(setSingleSitesAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* getSiteUnitListSaga(action: { payload: any }): any {
  const { siteId, page, limit, orderBy, orderIn } = action.payload;
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/sites/${siteId}/units?page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}`,
      "",
      V2_CONFIG,
    );
    if (res?.data) {
      yield put(setSiteUnitListResponse(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* addSiteUnitSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { siteId, ...rest } = payload.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: rest },
      "post",
      `storage/sites/${siteId}/units`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSiteUnitResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* updateSiteUnitSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { siteId, siteUnitId, ...rest } = payload.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: rest },
      "put",
      `storage/sites/${siteId}/units/${siteUnitId}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSiteUnitResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* getSingleSiteUnitSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    const { siteId, siteUnitId } = action.payload; // Directly access the payload
    let url = "";

    url = `storage/sites/${siteId}/units/${siteUnitId}`;

    const res = yield call<any>(callAPI, {}, "get", url, "", V2_CONFIG);

    if (res?.data) {
      yield put(setSingleSiteUnitResponse(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* deleteSiteUnitSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { siteId, siteUnitId } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `storage/sites/${siteId}/units/${siteUnitId}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteSiteUnitResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* updateSiteUnitStatusSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { siteId, siteUnitId, ...newPayload } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {payload:newPayload},
      "put",
      `storage/sites/${siteId}/units/${siteUnitId}/status`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(updateSiteUnitStatusResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  } finally {
    yield put(setLoaderAction(false));
  }
}

export function* watchStorageSetting() {
  yield takeLatest<any>(getAllUnitTypesAction, getAllUnitTypesSaga);
  yield takeLatest<any>(addUnitTypeAction, addUnitTypeSaga);
  yield takeLatest<any>(getSingleUnitTypeAction, getSingleUnitTypeSaga);
  yield takeLatest<any>(deleteUnitTypeAction, deleteUnitTypeSaga);
  yield takeLatest<any>(getAllSitesAction, getAllSitesSaga);
  yield takeLatest<any>(addSiteAction, addSiteSaga);
  yield takeLatest<any>(getSingleSitesAction, getSingleSitesSaga);
  yield takeLatest<any>(getSiteUnitListAction, getSiteUnitListSaga);
  yield takeLatest<any>(addSiteUnitAction, addSiteUnitSaga);
  yield takeLatest<any>(updateSiteUnitAction, updateSiteUnitSaga);
  yield takeLatest<any>(getSingleSiteUnitAction, getSingleSiteUnitSaga);
  yield takeLatest<any>(deleteSiteUnitAction, deleteSiteUnitSaga);
  yield takeLatest<any>(updateSiteUnitStatusAction,updateSiteUnitStatusSaga);
}